import metadataProvider from './classes/MetadataProvider';
const cornerstone = { metadataProvider };
export default cornerstone;
